import BrokerContainer from "./BrokerContainer";
import BrokerStore from "./BrokerStore";

export default BrokerStore(BrokerContainer);